import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NavigationService } from '../../../core/service/navigation.service';
import { Features, ModuleNames } from '../../model/account-definition';
import { UserAccountService } from '../user-account.service';

@Injectable()
export class LandlordAccountGuard {
  constructor(
    private readonly _userAccount: UserAccountService,
    private readonly _navigation: NavigationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this._userAccount.current.pipe(
      map(account => {
        if (account.hasAccess(ModuleNames.System, Features.Admin)) return true;

        this._navigation.navigatePageNotFound();
        return false;
      })
    );
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(childRoute, state);
  }
}
